import ErrorPage from 'components/base/ErrorPage';

const NotFound = () => {
  return <ErrorPage title="404" details="The requested page cannot be found" />;
};

export default NotFound;
